export default "__VITE_ASSET__5Hr7lG_Z__"